import ClassFeatureSnippet from "./ClassFeatureSnippet";

export default ClassFeatureSnippet;
export { ClassFeatureSnippet };
